

import {Component, Vue} from "vue-property-decorator"
import {
  createContainerType,
  deleteContainerType,
  getContainerTypeList,
  updateContainerType
} from "@/api/container-type-configuration";
import { cloneDeep } from "lodash";
import { Form } from "element-ui";

@Component({
  name:'ContainerTypeConfiguration'
})

export default class extends Vue {

  private containerTypeList: ContainerType[] = []

  private actionNameDict = {create: "新增",update: "修改"}
  private dialogStatus: string = null
  private dialogFormVisible = false


  private  defaultContainerType: ContainerType = {
    id: null,
    name: null,
    updatedAt:null,
    value:null
  };

  private payload: ContainerType = cloneDeep(this.defaultContainerType)

  private rules = {
    name: [{ required: true, message: "请输入柜型名称"}],
    value: [{ required: true, message: "请输入柜型名称"}],
  };

  created(){
    this.getList()
  }

  public async getList(){
    const data: any = await getContainerTypeList()
    this.containerTypeList = data
  }

  public showDialog(action:string, row: ContainerType){
    if (row) {
      this.payload = cloneDeep(row)
    }else {
      this.payload = cloneDeep(this.defaultContainerType)
    }
    this.dialogStatus = action;
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  public onDialogConfirmed(){
    if (this.dialogStatus === "create") {
      this.doCreate()
    }else if (this.dialogStatus === "update") {
      this.doUpdate()
    }
  }

  public onDelete(id:string){
    this.doDelete(id)
  }

  public doCreate(){
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        await createContainerType({name:this.payload.name,value:this.payload.value})
        this.dialogFormVisible = false;
        this.$notify({
          title: "成功",
          message: "创建成功",
          type: "success",
          duration: 2000
        });
      }
      await this.getList()
    });
  }

  public async doDelete(id: string){
    await deleteContainerType(id)
    this.dialogFormVisible = false;
    await this.getList()
  }

  private async doUpdate(){
    await updateContainerType(this.payload.id,{name: this.payload.name,value:this.payload.value})
    this.dialogFormVisible = false;
    await this.getList()
  }

}

class ContainerType {
  id: string
  name: string
  updatedAt: string
  value:string
}
